<template>
  <div class="w-full py-6 box-border relative">
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
      {{ title }}
    </header>
    <div class="w-full mt-3 pl-6 pr-4 box-border overflow-hidden">
      <slot name="head-extend"></slot>
      <div v-if="text" class="text-medium leading-24 font-normal mb-2 text-theme-black-850">
        {{ text }}
      </div>
      <div v-else class="px-3 py-2 box-border bg-bg-common-color flex">
        <p class="flex-1 text-medium text-theme-black-650 leading-5" v-if="content">
          {{ content }}
        </p>
        <p class="flex-1 text-medium text-theme-black-650 leading-5" v-else>
          线上结算服务中，调研工厂将按调查员到手金额的 {{ ratioVal }}% 收取费用，用于调查员代缴税及平台技术服务费。
        </p>
      </div>
      <div class="mt-3 text-medium flex items-center">
        <el-select v-model="calcType" class="mr-3 flex-1 theme-text-gray" placeholder="调查员到手金额">
          <el-option label="费用预算" :value="calcTypes.FFYS" />
          <el-option label="调查员到手金额" :value="calcTypes.DCYDSJE" />
        </el-select>
        <input-field-number
          class="theme-text-gray field-num-left w-80px"
          controls-position="right"
          :precision="2"
          :min="0"
          v-model="amount"
        />
        <span class="ml-2 text-medium text-theme-black-650">元</span>
      </div>
      <div class="mt-3 text-right pr-4" :style="{ overflow: 'auto', width: '100%', height: '45px' }">
        <label class="text-medium text-theme-black-650 whitespace-nowrap text-right">{{ calcLabelText }}：</label>
        <span class="text-20 text-danger">{{ calcAmount }}</span>
        <span class="ml-2 text-medium text-danger">元</span>
      </div>
    </div>
    <div class="absolute bottom-0 w-full h-px pl-6 pr-4 box-border" v-if="border">
      <div class="w-full f-full border-b border-solid border-theme-gray" />
    </div>
  </div>
</template>

<script>
import InputFieldNumber from '@/components/base/InputFieldNumber'
import { propMixins } from '@/mixins/publish'

const calcTypes = {
  FYYS: 1,
  DCYDSJE: 2
}

export default {
  name: 'AccountCalculator',
  mixins: [propMixins],
  components: {
    InputFieldNumber
  },
  props: {
    ratio: {
      type: Number,
      default: 6.5,
      validator(val) {
        return val >= 0 && val <= 100
      }
    },
    title: {
      type: String,
      default: '充值计算器'
    },
    text: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      amount: 0,
      calcTypes,
      calcType: calcTypes.FFYS
    }
  },
  computed: {
    ratioVal() {
      return +this.ratio || 6.5
    },
    decimalRatio() {
      const nr = this.ratioVal
      if (Number.isNaN(nr)) return 0
      const [, decimal] = `${nr}`.split('.')
      const fillNum = 10 ** (decimal || '').length
      return (nr * fillNum) / (100 * fillNum)
    },
    multipliedUp() {
      const calcNum = (this.amount || 0) * (100 + this.ratioVal)
      const mu = Number.isInteger(calcNum) ? calcNum / 100 : Math.ceil(calcNum) / 100
      return mu
    },
    dividingDown() {
      const calcNum = ((this.amount || 0) * 100) / (1 + this.decimalRatio)
      const dd = Number.isInteger(calcNum) ? calcNum / 100 : Math.floor(calcNum) / 100
      return dd
    },
    calcAmount() {
      let amt = 0
      if (this.calcType === calcTypes.FFYS) {
        amt = this.dividingDown
      } else if (this.calcType === calcTypes.DCYDSJE) {
        amt = this.multipliedUp
      }
      const [zNum, dNum] = `${amt}`.split('.')
      return `${zNum ?? 0}.${dNum?.[0] ?? 0}${dNum?.[1] ?? 0}`
    },
    calcLabelText() {
      if (this.calcType === calcTypes.FFYS) {
        return '调查员到手金额'
      } else if (this.calcType === calcTypes.DCYDSJE) {
        return '需充值金额'
      }
      return '充值金额'
    }
  }
}
</script>

<style lang="scss" scoped>
.w-80px {
  width: 80px !important;
}
.field-num-left {
  ::v-deep input {
    text-align: left;
  }
}
</style>
